import React, { Component } from 'react'
import { getReferences } from '../../services/vu'
import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material'

export default class ParentEducationLevel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      educationLevels: []
    }
  }

  componentDidMount() {
    getReferences().then(references => {
      const educationLevels = references.soneParentsEducationLevelList

      this.setState({
        educationLevels: educationLevels
      })
    })
  }

  render() {
    return this.state.educationLevels.length && (
      <div>
        <FormControl variant='standard' fullWidth>
          <Select
            className="dropdown"
            name={this.props.name}
            label="Qualification"
            onChange={this.props.onChange}
            value={this.props.value}
          >
            {this.state.educationLevels.length && this.state.educationLevels.map(educationalLevel => 
              <MenuItem key={educationalLevel.code} value={educationalLevel.code}>{educationalLevel.description}</MenuItem>
            )}
          </Select>
        </FormControl>

        {this.props.errors ? (
          <FormHelperText error>{this.props.helperText}</FormHelperText>
        ) : null}
      </div>
    )
  }
}
